import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { APP_CONFIG } from '../../config/app-config';
import { buildApiUrl } from '../api-http/form-url-encoded';

export interface MermaDia {
  fecha: string;
  fotosvendidas: number;
  mermas: number;
  fotosimpresas: number;
}

@Injectable()
export class MermasProvider {
  constructor(private http: HttpClient) {}

  consultar(apiKey: string, idlocacion: number | string, inicio: string, fin: string): Promise<MermaDia[]> {
    const path = 'punto-venta/mermas?idlocacion=' + encodeURIComponent(String(idlocacion)) +
      '&fechainicio=' + encodeURIComponent(inicio) + '&fechafin=' + encodeURIComponent(fin);
    return this.http.get<any>(buildApiUrl(APP_CONFIG.apiBaseUrl, path), {
      headers: new HttpHeaders({ Authorization: apiKey })
    }).toPromise().then(function (response: any) {
      if (!response || String(response.code) === '1') { throw new Error(response && response.message || 'No fue posible consultar las mermas.'); }
      return response.data && Array.isArray(response.data.registros) ? response.data.registros : [];
    });
  }

  guardar(apiKey: string, idlocacion: number | string, fecha: string, cantidad: number): Promise<void> {
    return this.http.post<any>(buildApiUrl(APP_CONFIG.apiBaseUrl, 'punto-venta/mermas'), {
      idlocacion: Number(idlocacion), fecha: fecha, cantidad: cantidad
    }, { headers: new HttpHeaders({ Authorization: apiKey, 'Content-Type': 'application/json' }) }).toPromise()
      .then(function (response: any) {
        if (!response || String(response.code) === '1') { throw new Error(response && response.message || 'No fue posible guardar la merma.'); }
      });
  }
}



// WEBPACK FOOTER //
// ./src/providers/mermas/mermas.ts